/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Mon Jul 17 2023 13:55:54 PM
 *
 *******************************************************/
//@flow

import React from 'react';
import { Icon, TextStyle, ProgressBar } from '@shopify/polaris';
import { ExitMajor } from '@shopify/polaris-icons';

export const FullscreenBar = (props: Object) => {
  const { backTitle, title, actions, onAction, progress, middleContent } = props;
  return (
    <>
      <div className="BC-FullscreenBar Polaris-FullscreenBar">
        {backTitle && (
          <button className="Polaris-FullscreenBar__BackAction" onClick={onAction}>
            <Icon source={ExitMajor} />
            {backTitle}
          </button>
        )}
        <div className="BC-FullscreenBar-Content">
          <span className="BC-FullscreenBar-Content_Title">
            <TextStyle variation="strong">{title}</TextStyle>
          </span>
          <span className="BC-FullscreenBar-Content_Middle">{middleContent}</span>
          <div className="BC-FullscreenBar-Content_Actions">{actions}</div>
        </div>
      </div>
      {progress !== -1 && (
        <div className="BC-Fullscreen-ProgressBar">
          <ProgressBar progress={progress} color="primary" />
        </div>
      )}
    </>
  );
};
